<iq-dialog-header
  header="Please select a store to continue"
  [showCloseButton]="false"
></iq-dialog-header>
<iq-form-field class="store-selector-search-filter" icon="search">
  <input
    type="text"
    placeholder="Quick search for stores"
    iqInput
    [(ngModel)]="searchTerm"
    (input)="onInput()"
  />
</iq-form-field>
<b>
  All stores
</b>
<iq-single-selection-list
  *ngIf="singleSelectableStore"
  class="store-list"
  [singleSelectionItem]="singleSelectableStore"
  (validSelection)="onValidSelection($event)"
>
  <div
    *ngIf="this.singleSelectableStore.options.length === 0"
    class="not-found-text"
  >
    Oops! Your search has returned no results. Please try again.
  </div>
  <div class="iq-dialog-buttons">
    <button
      type="submit"
      class="button primary-1"
      [disabled]="this.singleSelectableStore.options.length === 0"
    >
      Save
    </button>
    <button
      *ngIf="singleSelectableStore.allowCancel"
      type="button"
      class="button secondary-4"
      (click)="onExit()"
    >
      Exit
    </button>
  </div>
</iq-single-selection-list>
<iq-selectable-list
  *ngIf="multiSelectableStore"
  class="store-list"
  [selectableItems]="displayStores"
  [allowEmptySelection]="false"
  [errorCode]="'errors.forms.addUser.stores.required'"
  (validSelection)="onValidSelection($event)"
  (checked)="onChecked($event)"
>
  <div *ngIf="this.multiSelectableStore.length === 0" class="not-found-text">
    Oops! Your search has returned no results. Please try again.
  </div>
  <div class="iq-dialog-buttons">
    <button
      type="submit"
      class="button primary-1"
      [disabled]="this.multiSelectableStore.length === 0"
    >
      Save
    </button>
    <button
      *ngIf="allowCancel"
      type="button"
      class="button secondary-4"
      (click)="onExit()"
    >
      Exit
    </button>
  </div>
</iq-selectable-list>
